import { Typography } from "@material-ui/core";
import React from "react";
import ReportPageHeader from "./ReportPageHeader";

const styles = {
    sectionTitle: {
        color: "black",
        fontSize: "11px",
        fontWeight: 700,
        fontStyle: "italic",
        textAlign: "left",
        paddingLeft: 20,
        marginBottom: 4,
    },
    tableHeader: {
        backgroundColor: "#E0E0E0",
        color: "black",
        fontSize: "10px",
        fontWeight: 600,
        textAlign: "center",
        padding: "6px 2px",
    },
    tableCell: {
        color: "#000",
        fontSize: "9px",
        fontWeight: 400,
        textAlign: "center",
        padding: "2px 2px",
        border: "1px solid #ddd",
        height: "30px",
    },
};

/**
 * Page 4 — Hourly Radon Concentration table continuation.
 * Shows data in 3-column layout.
 * Picks up from where PageChart left off (startIndex = 24).
 */
const PageRadonTable = ({ reportDetails, reportChartRadonValue }) => {
    if (!reportDetails) return null;

    const ITEMS_PER_COL = 16; // 48 total data points / 3 columns

    const remaining = reportChartRadonValue || [];

    const rows = [];
    for (let i = 0; i < ITEMS_PER_COL; i++) {
        const col1Idx = i;
        const col2Idx = i + ITEMS_PER_COL;
        const col3Idx = i + ITEMS_PER_COL * 2;
        rows.push({
            col1: { data: col1Idx < remaining.length ? remaining[col1Idx] : null, num: col1Idx + 1 },
            col2: { data: col2Idx < remaining.length ? remaining[col2Idx] : null, num: col2Idx + 1 },
            col3: { data: col3Idx < remaining.length ? remaining[col3Idx] : null, num: col3Idx + 1 },
        });
    }

    const thStyle = styles.tableHeader;
    const tdStyle = styles.tableCell;

    const renderCells = ({ data, num }) => {
        if (data === null) {
            return (
                <>
                    <td style={tdStyle}>{""}</td>
                    <td style={tdStyle}>{""}</td>
                </>
            );
        }
        return (
            <>
                <td style={tdStyle}>{num}</td>
                <td style={tdStyle}>{data?.radon_level ?? ""}</td>
            </>
        );
    };

    return (
        <div style={{ height: "750px", overflow: "hidden" }}>
            {/* ===== Shared Header ===== */}
            <ReportPageHeader reportDetails={reportDetails} />

            <div style={{ paddingLeft: 20, paddingRight: 20, marginTop: 5 }}>
                <Typography style={{ ...styles.sectionTitle, paddingLeft: 0, marginTop: 0 }}>Hourly Radon Concentration</Typography>
                <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
                    <thead>
                        <tr>
                            <th style={thStyle}>Reading #</th>
                            <th style={thStyle}>Radon Level</th>
                            <th style={thStyle}>Reading #</th>
                            <th style={thStyle}>Radon Level</th>
                            <th style={thStyle}>Reading #</th>
                            <th style={thStyle}>Radon Level</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, idx) => (
                            <tr key={idx}>
                                {renderCells(row.col1)}
                                {renderCells(row.col2)}
                                {renderCells(row.col3)}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default PageRadonTable;
